import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { fallback } from '@/lib/utils/zodFallback';
import { AdminTranslationsTable } from '../-components/AdminTranslationsTable';
import { adminTranslationNamespacesQueryOptions } from '../-hooks/useAdminTranslations';
import { useAdminTranslationsPage } from '../-hooks/useAdminTranslationsPage';

const translationsSearch = z.object({
  page: fallback(z.number().int().min(1), 1),
  limit: fallback(z.number().int().min(10).max(500), 50),
  filters: z
    .union([
      z.string().transform(v => {
        try {
          return JSON.parse(v) as Record<string, string[]>;
        } catch {
          return undefined;
        }
      }),
      z.record(z.string(), z.array(z.string())),
    ])
    .optional(),
});

export const Route = createFileRoute('/management/translations/(pages)/')({
  validateSearch: translationsSearch,
  // A prefetch: rejecting would hide the table's own "Could not load" banner.
  loader: () =>
    queryClient
      .ensureQueryData(adminTranslationNamespacesQueryOptions)
      .catch(() => undefined),
  component: TranslationsPage,
});

function TranslationsPage() {
  const page = useAdminTranslationsPage();

  return (
    <PageContainer>
      <AdminTranslationsTable page={page} />
    </PageContainer>
  );
}
